<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { navTypeEnums } from "~/utils/enums/sessions.enums";

defineProps({
  validated: {
    type: Boolean,
    default: false,
  },
  project: {
    type: Boolean,
    default: false,
  },
  sessionStatus: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div class="tag__main body_regular flex items-center">
    <div v-if="validated && sessionStatus === navTypeEnums.COMING" class="tag__container">
      <SvgIcon name="forward" class="h-[16px] w-[16px]"></SvgIcon>
      <span class="text-center body_regular w-max">À venir</span>
    </div>
    <div v-else-if="validated && sessionStatus === navTypeEnums.IN_PROGRESS" class="tag__container">
      <SvgIcon name="date" class="h-[16px] w-[16px]"></SvgIcon>
      <span class="text-center body_regular w-max">En cours</span>
    </div>
    <div v-else-if="validated && sessionStatus === navTypeEnums.FINISHED" class="tag__container">
      <SvgIcon name="graduation_cap_on_v2" class="h-[16px] w-[16px]"></SvgIcon>
      <span class="text-center body_regular w-max">Passée</span>
    </div>
    <div v-else-if="project" class="tag__container">
      <SvgIcon name="duration" class="h-[16px] w-[16px]"></SvgIcon>
      <span class="text-center body_regular w-max">Brouillon</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tag__main {
  background: var(--grey-lightest);
  color: var(--text-secondary-color);
  padding: 4px 8px;
  border-radius: 8px;

  .tag__container {
    @apply inline-flex items-center gap-[4px];
  }

  img {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    max-width: 16px;
    max-height: 16px;
  }
}
</style>
